import { Form, InputNumber, Row } from 'antd';
import styled from 'styled-components';

interface CardOptionProps {
    $selected?: boolean;
    $colors?: {
        background: string;
        wrapperIcon: string;
    };
}

export const ContainerArea = styled.div`
    height: auto;
    position: relative;
`;

export const FormPlanogramContainer = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    padding: 0px 24px 90px 24px;
    gap: 24px;
    height: calc(80vh - 76px - 72px);
    overflow-y: auto;
    scrollbar-width: none;
    -ms-overflow-style: none;
    position: relative;

    &::-webkit-scrollbar {
        display: none;
    }

    position: relative;
`;

export const FormPlanogramContent = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 12px 16px;
    border: 1px solid
        ${(props) =>
            props.theme.theme === 'light'
                ? '#f0f0f0'
                : props.theme.colors.antdBorder};
    border-radius: 8px;
    position: relative;

    & > .ant-row {
        margin: 0px 0px !important;
    }

    & .ant-col {
        padding-left: 0px !important;
    }
`;

export const FormPlanogramWrapper = styled.div`
    position: relative;
`;

export const CardOption = styled.button<CardOptionProps>`
    display: flex;
    gap: 16px;

    width: 100%;
    padding: 12px;

    background: ${({ $selected, $colors, theme }) =>
        $selected
            ? $colors?.background || '#F6F6F6'
            : theme.theme === 'light'
            ? '#FFFFFF'
            : '#1F1F1F'};

    border: 1px solid
        ${(props) =>
            props.theme.theme === 'light'
                ? '#f0f0f0'
                : props.theme.colors.antdBorder};
    border-radius: 8px;

    cursor: pointer;
    text-align: left;

    transition: all 0.2s ease;

    &:hover {
        background: ${({ $selected, $colors, theme }) =>
            $selected
                ? $colors?.background || '#f6f6f6'
                : theme.theme === 'light'
                ? '#f6f6f6'
                : '#e0e0e0'};
    }

    &:active {
        transform: scale(0.98);
    }
`;

export const IconWrapper = styled.div<CardOptionProps>`
    min-width: 48px;
    min-height: 48px;

    display: flex;
    align-items: center;
    justify-content: center;
    background: ${({ $selected, $colors, theme }) =>
        $selected
            ? $colors?.wrapperIcon || '#30374A'
            : theme.theme === 'light'
            ? '#F0F0F0'
            : '#2C2C2C'};
    color: ${({ $selected, theme }) =>
        $selected
            ? '#FFFFFF'
            : theme.theme === 'light'
            ? '#31374A'
            : '#C0C0C0'};
    border-radius: 4px;
    font-size: 24px;
    align-self: flex-start;
`;

export const Content = styled.div`
    display: flex;
    flex-direction: column;
    gap: 3px;
`;

export const Title = styled.span`
    font-size: 16px;
    font-weight: 500;
    color: #8c8c8c;
    color: ${(props) => (props.theme.theme === 'dark' ? '#8c8c8c' : '#262626')};
`;

export const Description = styled.span`
    font-size: 14px;
    color: #8c8c8c;
    font-weight: 400;
    line-height: 1.4;
`;

export const CardsContainer = styled.div`
    display: flex;
    gap: 8px;

    @media (max-width: 768px) {
        flex-direction: column;
    }
`;

export const CardChangeSelect = styled.div`
    position: absolute;
    top: 16px;
    right: 16px;
`;

export const CardFieldArea = styled.div`
    display: flex;
    flex-direction: column;
    margin-bottom: 8px;
    gap: 8px;
`;

export const AddonWrapper = styled.div<{ active?: boolean }>`
    display: flex;
    align-items: center;
    cursor: pointer;
    padding: 0 12px;
    display: flex;
    align-items: center;
    border: 1px solid ${({ theme }) => theme.colors.antdBorder};
    background: ${({ theme }) =>
        theme.theme === 'light' ? '#41A9FF' : '#1F1F1F'};
    background: ${({ active }) => (active ? '#41A9FF' : 'transparent')};
    border-left: none;
    border-radius: 0 6px 6px 0;
`;

export const InfoLabel = styled.label`
    display: block;
    font-size: 14px;
    font-weight: 400;
    color: #8c8c8c;
    margin-top: -4px;
`;

export const OptionsArea = styled.div`
    display: flex;
    gap: 16px;
`;

export const OptionLabelArea = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`;

export const OptionLabel = styled.span`
    font-size: 14px;
    color: ${(props) => (props.theme.theme === 'light' ? '#262626' : '#fff')};
    font-weight: 500;
`;

export const OptionsAreaWrapper = styled.div`
    display: flex;
    gap: 16px;
`;

export const CustomRow = styled(Row)`
    margin: 0px 0px !important;
    .ant-row {
        margin: 0px 0px !important;
    }
`;

export const Paragraph = styled.p`
    font-size: 16px;
    color: ${(props) => (props.theme.theme === 'light' ? '#262626' : '#fff')};
    margin: 0px;
    font-weight: 400;
`;

export const List = styled.ul`
    padding-left: 30px;
    margin-bottom: 8px;
    color: ${(props) => (props.theme.theme === 'light' ? '#262626' : '#fff')};
    margin: 0px;
`;

export const ListItem = styled.li`
    font-size: 14px;
    line-height: 1.5;
    margin: 0px;
`;

export const ListSubTitle = styled.h2`
    font-size: 16px;
    color: #8c8c8c;
    font-weight: 400;
    margin: 0px;
`;

export const NoMarginFormItem = styled(Form.Item)`
    margin-bottom: 0 !important;

    .ant-row {
        margin: 0px 0px !important;
    }
`;

export const StyledInputNumber = styled(InputNumber)<{ $addon?: boolean }>`
    background: ${({ $addon, theme }) =>
        $addon && theme.theme === 'light'
            ? '#f5f5f5'
            : 'transparent'} !important;
`;
